import { render, staticRenderFns } from "./myLeave.vue?vue&type=template&id=d56a7210&scoped=true"
import script from "./myLeave.vue?vue&type=script&lang=js"
export * from "./myLeave.vue?vue&type=script&lang=js"
import style0 from "./myLeave.vue?vue&type=style&index=0&id=d56a7210&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56a7210",
  null
  
)

export default component.exports